<template>
    <el-dialog :visible.sync="isSet" :before-close="handleClose" title="配置视频热度统计方式" class="withDrawal"
        style="800px" v-loading="loading">
        <div class="inputBox">
            <div class="inputItem">
            <div class="text">点赞量放大因子</div>
            <el-input type='text' clearable style='width:160px; margin:10px 0px 10px 24px' min="0" placeholder="点赞量放大因子" v-model="LikeCountMultiplier"></el-input>
            </div>
            <div class="inputItem">
                <div class="text">有效播放量放大因子</div>
                <el-input type='text' clearable style='width:160px; margin:10px 0px 10px 24px' min="0" placeholder="有效播放量放大因子" v-model="effectivePlayCountMultiplier"></el-input>
            </div>
        </div>
        <div class="inputBox">
            <div class="inputItem">
            <div class="text mr28">初始热度值</div>
            <el-input type='text' clearable style='width:160px; margin:10px 0px 10px 24px' min="0" placeholder="初始热度值" v-model="initalPop"></el-input>
            </div>
            <div class="inputItem">
                <div class="text">过审时长幂次</div>
                <el-input type='text' clearable style='width:160px; margin:10px 0px 10px 24px' min="0" placeholder="过审时长幂次" v-model="reviewTimePower"></el-input>
            </div>
        </div>
        
        <div style="display:flex;flex-direction: row-reverse;width: 670px;margin: 14px auto 0;justify-content: space-between;">
            <div style="display: flex;flex-direction: column;justify-content: center;">
                <el-button icon="el-icon-plus" type="success" plain @click="addConfig"></el-button>
                <el-button style="margin: 10px 0 10px 0;" icon="el-icon-minus" type="success" plain @click="delConfig"></el-button>
            </div>
            <div style="align-self: center;">
                <div v-for=" (k,i) in nums" :key="k" style="margin: 0px 0px 0px 16px;display:flex">
                    <div style="text-align: center;color: #b7b7b7;display:inline-block;align-self: center;">第{{i+1}}组</div>
                    <el-input type='text' clearable style='width:160px; margin:10px 0px 10px 24px' min="0" v-model="configArr[i].min" placeholder="视频时长下限(分)"></el-input>
                    <el-input type='text' style='width:150px; margin:10px 20px 10px 24px' v-model="configArr[i].max" placeholder="视频时长上限(分)"></el-input>
                    <el-input type='text' style='width:150px; margin:10px 20px 10px 0' min="0" v-model="configArr[i].percentage" placeholder="有效播放时长比例"></el-input>
                    <br>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="success" plain @click="cancelSet">取 消</el-button>
            <el-button type="primary" @click="modifyVidPopularity">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import API from "@/api";
export default {
    data() {
        return {
            isSet: false,
            nums: 1,
            configArr: [
                {
                    min: "",
                    max: "",
                    percentage: "",
                }
            ],
            LikeCountMultiplier: "",
            effectivePlayCountMultiplier: "",
            initalPop: "",
            reviewTimePower: "",
            loading: false,
        }
    },
    created() {},
    methods: {
        // 获取视频热度计算方式
        async queryVidPopularity() {
            this.loading = true;
            let ret = await API.queryVidPopularity();
            if (ret && ret.code == 200) {
                this.LikeCountMultiplier = ret.data.LikeCountMultiplier || 0;
                this.effectivePlayCountMultiplier = ret.data.effectivePlayCountMultiplier || 0;
                this.initalPop = ret.data.initalPop || 0;
                this.reviewTimePower = ret.data.reviewTimePower || 0;
                if (ret.data.playTimePercentage && ret.data.playTimePercentage.length > 0) {
                    this.configArr = ret.data.playTimePercentage.map(i => {
                        i.min = i.min / 60;
                        i.max = i.max / 60;
                        return i;
                    });
                    this.nums = ret.data.playTimePercentage.length;
                }
            }
            this.loading = false;
        },
        async modifyVidPopularity() {
            let validateReq = '';
            
            this.configArr.forEach(i => {
                if (i.min === '') {
                    validateReq = 'min';
                } else if (i.max === '') {
                    validateReq = 'max'
                }else if (i.percentage === '') {
                    validateReq = 'percentage';
                }
            })
            if (validateReq == 'min') {
                this.$message.error('请输入视频时长下限');
                return;
            }
            if (validateReq == 'max') {
                this.$message.error('请输入视频时长上限');
                return;
            }
            if (validateReq == 'percentage') {
                this.$message.error('请输入有效时长比例');
                return;
            }
            let req = {
                LikeCountMultiplier: Number(this.LikeCountMultiplier),
                effectivePlayCountMultiplier: Number(this.effectivePlayCountMultiplier),
                initalPop: Number(this.initalPop),
                reviewTimePower: Number(this.reviewTimePower),
                playTimePercentage: this.configArr,
            }
            req.playTimePercentage.forEach(i => {
                i.min = Number(i.min);
                i.max = Number(i.max);
                i.percentage = Number(i.percentage);
            })
            let ret = await API.modifyVidPopularity(req);
            if (ret && ret.code == 200) {
                this.isSet = false;
                this.$message.success('配置成功');
            }
            // console.log(ret);
        },
        // 添加行
        addConfig() {
            this.nums++;
            this.configArr.push({
                min: "",
                max: "",
                percentage: "",
            })
        },
        // 删除行
        delConfig() {
            if (this.nums > 1) {
                this.nums--;
                this.configArr.pop();
            }
        },
        // 取消
        cancelSet() {
            this.isSet = false;
        },
        // 确认设置
        confirmSet() {
            console.log();
        },
        // 打开弹窗
        open() {
            this.isSet = true;
            this.queryVidPopularity();
        },
        // 关闭弹窗
        handleClose() {
            this.isSet = false;
            this.nums = 1;
            this.configArr = [{
                min: "",
                max: "",
                percentage: "",
            }];
            this.LikeCountMultiplier = "";
            this.effectivePlayCountMultiplier = "";
            this.initalPop = "";
            this.reviewTimePower = "";
            console.log(123123)
        },
    }
}
</script>

<style lang="scss" scoped>
.inputBox {
    display: flex;
    justify-content: space-between;
    width: 670px;
    margin: 0 auto;
    .inputItem {
        display: flex;
        align-items: center;
        为
        .text {
            display: inline-block;
        }
    }
}
.mr28 {
    margin-right: 28px;
}  
</style>